import { Locale, LOCALES } from 'config/constants/locales';

export const isSupportedLocale = (locale?: string | null): locale is Locale => {
  return Object.values(LOCALES).includes(locale as Locale);
};
